import { render, staticRenderFns } from "./devtype.vue?vue&type=template&id=1c091788&scoped=true"
import script from "./devtype.vue?vue&type=script&lang=js"
export * from "./devtype.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c091788",
  null
  
)

export default component.exports